import { useTranslation } from "react-i18next";
type PropsType = {
  label?: string;
  name?: string;
  register?: any;
  required?: boolean;
  watch?: any;
  type?: string;
  min?: any;
  max?: any;
  errors?: any;
  icon?: any;
  parentClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  onChange?: any;
  start_with?: any;
  float?: boolean;
  withoutLabel?: boolean;
  height?: string;
  fixedIcon?: boolean;
};

const Input: React.FC<PropsType> = ({
  name,
  label,
  register,
  required,
  watch,
  height = "h-[35px]",
  type = "text",
  errors,
  min,
  max,
  icon,
  parentClassName,
  labelClassName,
  start_with,
  disabled = false,
  onChange,
  float = false,
  withoutLabel = false,
  fixedIcon = false,
}) => {
  const { i18n } = useTranslation();
  const validationStyle = () => {
    if (errors[name]) {
      return "ring-red-600 ring-2";
    } else {
      return "";
    }
  };
  const responseiveIconDirectionIcon = () => {
    if (icon && i18n.language === "ar" && fixedIcon === false) {
      return "right-0 rounded-r-xl";
    } else if (icon && i18n.language === "en") {
      return "left-0 rounded-l-xl";
    } else {
      return "left-0 rounded-r-xl";
    }
  };
  const responseiveIconDirection = () => {
    if (!icon) {
      return "px-3";
    } else if (icon && i18n.language === "ar") {
      return "pr-11";
    } else if (icon && i18n.language === "en") {
      return "pl-11";
    } else {
      return "";
    }
  };

  return (
    <div
      dir={fixedIcon === true ? "ltr" : i18n.language === "en" ? "ltr" : "rtl"}
      className={`flex w-full flex-col ${parentClassName}`}
    >
      <div className={`relative flex items-center w-full ${height} my-2 group`}>
        {withoutLabel === false && (
          <label
            className={`absolute ${
              fixedIcon
                ? `${i18n.language === "ar" ? "right-3" : "left-12"}`
                : responseiveIconDirection()
            } capitalize group-hover:-translate-y-2.5  text-sm font-normal transition-all    duration-300 text-old-silver ${
              disabled || String(watch(name)).length > 0
                ? "-translate-y-2.5"
                : ""
            }  ${disabled ? "cursor-not-allowed" : ""} ${labelClassName}`}
          >
            {label ? label : name}
          </label>
        )}
        <input
          {...register(name, {
            onChange,
          })}
          required={required}
          aria-label={label}
          label={label ? label : name}
          type={type}
          autoComplete={type && type === "password" ? "new-password" : "off"}
          min={min}
          step={float === true ? "0.01" : "any"}
          max={max}
          disabled={disabled}
          className={`w-full h-full  ${
            disabled ? "cursor-not-allowed opacity-30" : ""
          } ${
            withoutLabel === false ? "pt-3" : ""
          } text-base font-bold outline-none ${
            fixedIcon ? "pl-11" : responseiveIconDirection()
          } appearance-none bg-[#F7F7F7] rounded-md text-[#585757] ${validationStyle()}`}
        />
        {icon ? (
          <div
            className={` absolute ${
              fixedIcon ? "left-0 rounded-l-xl" : responseiveIconDirectionIcon()
            } h-[35px]  flex items-center justify-center w-11 px-2 bg-[#F7F7F7] `}
          >
            {icon()}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Input;
